import React from 'react'
import { useHistory } from 'react-router-dom'
import { Spinner } from 'lib/ui/components'
import { useSubscriptionOrders } from 'hooks/subscriptions'
import { SubscriptionItem } from '../../../../components/SubscriptionItem'
import { Heading } from '../../components/Heading'

export const List = () => {
  const history = useHistory()
  const { customerSubscriptions, loading } = useSubscriptionOrders()

  if (loading) {
    return <Spinner />
  }

  if (customerSubscriptions?.length === 1) {
    const { subscription_id: id, sku } = customerSubscriptions[0]
    history.push(`/customer/account/subscriptions/detail/${id}/${sku}`)
  }

  return (
    <>
      <Heading />
      {customerSubscriptions ? (
        <div className='items-wrapper'>
          {customerSubscriptions?.map((subscription: any) => {
            return (
              <SubscriptionItem
                key={subscription.PDPID}
                item={subscription}
              />
            )
          })}
        </div>
      ) : (
        <h3>Nothing here yet!</h3>
      )}
    </>
  )
}
